module.exports = __webpack_public_path__ + "static/media/graph.bd3c0250.svg";